import { createFileRoute } from "@tanstack/react-router";
import WarehousesConfiguration from "@/components/warehouses/warehouses-configuration";
import { RouteGuardPermissions } from "@/components/permissions/route-guard-multiple";

export const Route = createFileRoute(
  "/_authenticated/settings/_layout/warehouses",
)({
  component: WarehousesPage,
});

function WarehousesPage() {
  return (
    <RouteGuardPermissions
      permissions={[{ module: "warehouses", actions: ["read"] }]}
    >
      <div>
        <div className="overflow-x-auto">
          <WarehousesConfiguration module="warehouses" />
        </div>
      </div>
    </RouteGuardPermissions>
  );
}
